/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/product-pages.
 *
 * One row per (product_slug, layout_kind). Today: values-incubator and
 * harbour. Image references in `blocks.modules[*].images[*].media_uuid`
 * resolve via `cmsMediaIndex` — until `scripts/migrate-static-product-images.mts`
 * runs, those keys are placeholders and resolve to nothing.
 *
 * The flat `subtitle` / `summary` / `hero_alt` / `blocks` / `cta` fields
 * mirror the zh-Hant copy, so a consumer that does not care about
 * locales keeps working unchanged. A locale-aware consumer reads
 * `locales[locale]` instead — see src/content/cms/productPageLocale.ts.
 */

export interface CmsProductPageLocaleCopy {
  subtitle: string
  summary: string
  hero_alt: string
  blocks: Record<string, unknown>
  cta: {
    tag: string
    title: string
    text: string
    whatsapp_label: string
    form_label: string
    closing: string
  }
}

export interface CmsProductPageIndexEntry {
  product_slug: string
  layout_kind: 'values-incubator' | 'harbour' | 'standard'
  subtitle: string
  summary: string
  hero_media_id: number | null
  hero_uuid: string | null
  hero_alt: string
  blocks: Record<string, unknown>
  cta: {
    tag: string
    title: string
    text: string
    whatsapp_label: string
    form_label: string
    closing: string
  }
  /**
   * Every locale's copy, resolved at build time.
   *
   * OPTIONAL: a file written by an older sync has no `locales` key at
   * all — the flat fields are then the zh-Hant copy, and every locale
   * renders it.
   */
  locales?: {
    'zh-Hant'?: CmsProductPageLocaleCopy
    'zh-Hans'?: CmsProductPageLocaleCopy
    en?: CmsProductPageLocaleCopy
  }
}

export const cmsProductPages: CmsProductPageIndexEntry[] = [
  {
    "product_slug": "values-incubator",
    "layout_kind": "values-incubator",
    "subtitle": "讓品格教育可行、切實、具實證 — 全方位家校攜手",
    "summary": "以科學實證為基礎，打造可測量、可持續的品格教育生態系。",
    "hero_media_id": null,
    "hero_uuid": null,
    "hero_alt": "ValuesIncubator+ 學生端：正面校園與解鎖獎卡",
    "blocks": {
      "coreFeaturesTag": "系統核心特色",
      "coreFeaturesTitle": "為何選擇 ValuesIncubator+",
      "stakeholdersTag": "為學校帶來的價值",
      "stakeholdersTitle": "對每一位持份者的承諾",
      "tableHeaders": {
        "feature": "功能",
        "description": "說明",
        "highlight": "特色",
        "stakeholder": "持份者",
        "value": "價值"
      },
      "coreFeatures": [
        {
          "title": "安全與私隱",
          "text": "學生以班級＋學號識別，無需個人電郵或帳戶；教師審閱機制確保報告質素；校長儀表板為唯讀權限。"
        },
        {
          "title": "跨平台與語言",
          "text": "流動裝置友善的網頁體驗；繁體中文及英文雙語介面；學生內容以輸入語言原樣儲存。"
        },
        {
          "title": "完整報告機制",
          "text": "學生解鎖與反思、教師頒發與檢視、管理員系統設定、校長唯讀影響力儀表板。"
        },
        {
          "title": "科學基礎",
          "text": "建基於成長型思維（Carol Dweck），融入強項為本的正向心理學，讓品格教育既具吸引力又具實效。"
        }
      ],
      "stakeholders": [
        {
          "role": "學生",
          "value": "獲得即時肯定、建立成長檔案、培養自我覺察"
        },
        {
          "role": "教師",
          "value": "簡化表揚流程、掌握學生進度、融入課堂活動"
        },
        {
          "role": "家長",
          "value": "透明了解子女成長、參與鼓勵、家校攜手"
        },
        {
          "role": "校長",
          "value": "數據驅動決策、證明教育成效、建立正向校園文化"
        }
      ],
      "modules": [
        {
          "id": "rewards",
          "name": "模組一：動態獎勵卡系統",
          "tagline": "從抽象價值到具體成就",
          "intro": "讓正面強化即時而有意義，將每一個品格成長的瞬間轉化為具體記錄。",
          "images": [
            {
              "media_uuid": "fae4984b-4811-4bec-98ba-f45f2b5a56da",
              "alt": "學生正面校園首頁：解鎖獎卡與家長專區",
              "caption": "學生端：正面校園與解鎖獎卡",
              "width": 763,
              "height": 849
            },
            {
              "media_uuid": "41b2d89a-833d-4090-ad68-504e1f9b0c34",
              "alt": "品格價值管理介面：自訂價值、卡面與雙語名稱",
              "caption": "管理端：品格價值與卡面設定",
              "width": 1105,
              "height": 898
            }
          ],
          "features": [
            {
              "title": "即時表揚",
              "description": "教師掃描 QR 碼即時頒發獎勵卡",
              "highlight": "即時肯定，強化正面行為"
            },
            {
              "title": "以學生為本",
              "description": "流暢且保障私隱的設計",
              "highlight": "無需電郵或帳戶，以班級學號識別"
            },
            {
              "title": "成長組合",
              "description": "從獎牌邁向獎盃的進階機制",
              "highlight": "輕鬆愉快建立個人成長檔案"
            },
            {
              "title": "反思與成長",
              "description": "學生反思表揚內容並記錄情緒",
              "highlight": "培養自我覺察與成長型思維"
            },
            {
              "title": "家長鼓勵",
              "description": "單一系統連結家長",
              "highlight": "家校攜手共同鼓勵學生成長"
            }
          ]
        },
        {
          "id": "admin",
          "name": "模組二：教師與行政管理工具",
          "tagline": "賦能教育工作者，精簡行政運作",
          "intro": "為教師和行政人員提供強大而直觀的工具，將品格教育無縫融入日常教學。",
          "images": [
            {
              "media_uuid": "a297c0ca-d2c9-4676-8cc2-a8fbf847c1d9",
              "alt": "教師管理後台儀表板：庫存統計與解鎖分析圖表",
              "caption": "管理面板：庫存、解鎖分析與老師成效",
              "width": 904,
              "height": 800
            }
          ],
          "features": [
            {
              "title": "課堂融入",
              "description": "教師管理虛擬獎勵卡",
              "highlight": "可建立與價值觀相關的課堂活動"
            },
            {
              "title": "全面掌控",
              "description": "完整追蹤獎勵卡生命週期",
              "highlight": "從庫存到分發，確保計劃貫徹執行"
            },
            {
              "title": "彈性自訂",
              "description": "自訂品格價值清單",
              "highlight": "根據學校獨特理念設定如「勇氣」、「同理心」等價值"
            },
            {
              "title": "批量管理",
              "description": "CSV 匯入匯出、QR 碼批量列印",
              "highlight": "節省行政時間，提升效率"
            }
          ]
        },
        {
          "id": "analytics",
          "name": "模組三：數據分析與 AI 報告",
          "tagline": "數據的力量：見證您啟發的成長",
          "intro": "衡量真正重要的事，提供洞察以展現教育影響力。",
          "images": [],
          "features": [
            {
              "title": "360 度全方位視角",
              "description": "匯集學生、教師和家長的多元回饋",
              "highlight": "全面掌握學生發展狀況"
            },
            {
              "title": "AI 生成報告",
              "description": "將解鎖紀錄轉化為個人化敘事報告",
              "highlight": "教師審閱後方可釋出，確保質素"
            },
            {
              "title": "校長儀表板",
              "description": "全校影響力唯讀儀表板",
              "highlight": "宏觀掌握計劃成效"
            },
            {
              "title": "趨勢分析",
              "description": "CSV 匯出與數據分析功能",
              "highlight": "協助優化策略並證明教育成效"
            },
            {
              "title": "獎章與獎牌計劃",
              "description": "自訂獎勵計劃及達標門檻",
              "highlight": "多元化激勵機制"
            }
          ]
        },
        {
          "id": "community",
          "name": "模組四：家校社群連結",
          "tagline": "建立緊密連結的社群",
          "intro": "品格發展跨越校園，連結家庭，建構完整的正向教育生態。",
          "images": [
            {
              "media_uuid": "d6c27aa3-acd5-499b-ae33-5fbbd7ee79df",
              "alt": "成就頁面：獎章等級與達標計劃進度",
              "caption": "成就與獎章計劃進度",
              "width": 599,
              "height": 820
            },
            {
              "media_uuid": "624b1e32-06e1-4045-84b1-64bf8e15e451",
              "alt": "學生／家長總覽：解鎖紀錄與成就標籤",
              "caption": "總覽：最近解鎖與家校同步",
              "width": 484,
              "height": 830
            }
          ],
          "features": [
            {
              "title": "家長入口網站",
              "description": "安全的專屬平台",
              "highlight": "展示孩子的進度、解鎖紀錄與報告"
            },
            {
              "title": "即時通知",
              "description": "可選電郵通知功能",
              "highlight": "讓家長分享每一次解鎖的喜悅"
            },
            {
              "title": "校外成就申報",
              "description": "學生上載校外成就及證明",
              "highlight": "全面記錄學生多元發展"
            },
            {
              "title": "家長鼓勵功能",
              "description": "家長可對孩子的成就表達鼓勵",
              "highlight": "加強家校情感連結"
            }
          ]
        }
      ]
    },
    "cta": {
      "tag": "立即行動",
      "title": "準備好建立品格文化了嗎？",
      "text": "讓我們一起起步 — 歡迎預約示範或索取更多資料。",
      "whatsapp_label": "WhatsApp 聯絡我們",
      "form_label": "填寫聯絡表單",
      "closing": "ValuesIncubator — 讓每一位學生的獨特強項被發掘、被慶祝、被培育。"
    },
    "locales": {
      "zh-Hant": {
        "subtitle": "讓品格教育可行、切實、具實證 — 全方位家校攜手",
        "summary": "以科學實證為基礎，打造可測量、可持續的品格教育生態系。",
        "hero_alt": "ValuesIncubator+ 學生端：正面校園與解鎖獎卡",
        "blocks": {
          "coreFeaturesTag": "系統核心特色",
          "coreFeaturesTitle": "為何選擇 ValuesIncubator+",
          "stakeholdersTag": "為學校帶來的價值",
          "stakeholdersTitle": "對每一位持份者的承諾",
          "tableHeaders": {
            "feature": "功能",
            "description": "說明",
            "highlight": "特色",
            "stakeholder": "持份者",
            "value": "價值"
          },
          "coreFeatures": [
            {
              "title": "安全與私隱",
              "text": "學生以班級＋學號識別，無需個人電郵或帳戶；教師審閱機制確保報告質素；校長儀表板為唯讀權限。"
            },
            {
              "title": "跨平台與語言",
              "text": "流動裝置友善的網頁體驗；繁體中文及英文雙語介面；學生內容以輸入語言原樣儲存。"
            },
            {
              "title": "完整報告機制",
              "text": "學生解鎖與反思、教師頒發與檢視、管理員系統設定、校長唯讀影響力儀表板。"
            },
            {
              "title": "科學基礎",
              "text": "建基於成長型思維（Carol Dweck），融入強項為本的正向心理學，讓品格教育既具吸引力又具實效。"
            }
          ],
          "stakeholders": [
            {
              "role": "學生",
              "value": "獲得即時肯定、建立成長檔案、培養自我覺察"
            },
            {
              "role": "教師",
              "value": "簡化表揚流程、掌握學生進度、融入課堂活動"
            },
            {
              "role": "家長",
              "value": "透明了解子女成長、參與鼓勵、家校攜手"
            },
            {
              "role": "校長",
              "value": "數據驅動決策、證明教育成效、建立正向校園文化"
            }
          ],
          "modules": [
            {
              "id": "rewards",
              "name": "模組一：動態獎勵卡系統",
              "tagline": "從抽象價值到具體成就",
              "intro": "讓正面強化即時而有意義，將每一個品格成長的瞬間轉化為具體記錄。",
              "images": [
                {
                  "media_uuid": "fae4984b-4811-4bec-98ba-f45f2b5a56da",
                  "alt": "學生正面校園首頁：解鎖獎卡與家長專區",
                  "caption": "學生端：正面校園與解鎖獎卡",
                  "width": 763,
                  "height": 849
                },
                {
                  "media_uuid": "41b2d89a-833d-4090-ad68-504e1f9b0c34",
                  "alt": "品格價值管理介面：自訂價值、卡面與雙語名稱",
                  "caption": "管理端：品格價值與卡面設定",
                  "width": 1105,
                  "height": 898
                }
              ],
              "features": [
                {
                  "title": "即時表揚",
                  "description": "教師掃描 QR 碼即時頒發獎勵卡",
                  "highlight": "即時肯定，強化正面行為"
                },
                {
                  "title": "以學生為本",
                  "description": "流暢且保障私隱的設計",
                  "highlight": "無需電郵或帳戶，以班級學號識別"
                },
                {
                  "title": "成長組合",
                  "description": "從獎牌邁向獎盃的進階機制",
                  "highlight": "輕鬆愉快建立個人成長檔案"
                },
                {
                  "title": "反思與成長",
                  "description": "學生反思表揚內容並記錄情緒",
                  "highlight": "培養自我覺察與成長型思維"
                },
                {
                  "title": "家長鼓勵",
                  "description": "單一系統連結家長",
                  "highlight": "家校攜手共同鼓勵學生成長"
                }
              ]
            },
            {
              "id": "admin",
              "name": "模組二：教師與行政管理工具",
              "tagline": "賦能教育工作者，精簡行政運作",
              "intro": "為教師和行政人員提供強大而直觀的工具，將品格教育無縫融入日常教學。",
              "images": [
                {
                  "media_uuid": "a297c0ca-d2c9-4676-8cc2-a8fbf847c1d9",
                  "alt": "教師管理後台儀表板：庫存統計與解鎖分析圖表",
                  "caption": "管理面板：庫存、解鎖分析與老師成效",
                  "width": 904,
                  "height": 800
                }
              ],
              "features": [
                {
                  "title": "課堂融入",
                  "description": "教師管理虛擬獎勵卡",
                  "highlight": "可建立與價值觀相關的課堂活動"
                },
                {
                  "title": "全面掌控",
                  "description": "完整追蹤獎勵卡生命週期",
                  "highlight": "從庫存到分發，確保計劃貫徹執行"
                },
                {
                  "title": "彈性自訂",
                  "description": "自訂品格價值清單",
                  "highlight": "根據學校獨特理念設定如「勇氣」、「同理心」等價值"
                },
                {
                  "title": "批量管理",
                  "description": "CSV 匯入匯出、QR 碼批量列印",
                  "highlight": "節省行政時間，提升效率"
                }
              ]
            },
            {
              "id": "analytics",
              "name": "模組三：數據分析與 AI 報告",
              "tagline": "數據的力量：見證您啟發的成長",
              "intro": "衡量真正重要的事，提供洞察以展現教育影響力。",
              "images": [],
              "features": [
                {
                  "title": "360 度全方位視角",
                  "description": "匯集學生、教師和家長的多元回饋",
                  "highlight": "全面掌握學生發展狀況"
                },
                {
                  "title": "AI 生成報告",
                  "description": "將解鎖紀錄轉化為個人化敘事報告",
                  "highlight": "教師審閱後方可釋出，確保質素"
                },
                {
                  "title": "校長儀表板",
                  "description": "全校影響力唯讀儀表板",
                  "highlight": "宏觀掌握計劃成效"
                },
                {
                  "title": "趨勢分析",
                  "description": "CSV 匯出與數據分析功能",
                  "highlight": "協助優化策略並證明教育成效"
                },
                {
                  "title": "獎章與獎牌計劃",
                  "description": "自訂獎勵計劃及達標門檻",
                  "highlight": "多元化激勵機制"
                }
              ]
            },
            {
              "id": "community",
              "name": "模組四：家校社群連結",
              "tagline": "建立緊密連結的社群",
              "intro": "品格發展跨越校園，連結家庭，建構完整的正向教育生態。",
              "images": [
                {
                  "media_uuid": "d6c27aa3-acd5-499b-ae33-5fbbd7ee79df",
                  "alt": "成就頁面：獎章等級與達標計劃進度",
                  "caption": "成就與獎章計劃進度",
                  "width": 599,
                  "height": 820
                },
                {
                  "media_uuid": "624b1e32-06e1-4045-84b1-64bf8e15e451",
                  "alt": "學生／家長總覽：解鎖紀錄與成就標籤",
                  "caption": "總覽：最近解鎖與家校同步",
                  "width": 484,
                  "height": 830
                }
              ],
              "features": [
                {
                  "title": "家長入口網站",
                  "description": "安全的專屬平台",
                  "highlight": "展示孩子的進度、解鎖紀錄與報告"
                },
                {
                  "title": "即時通知",
                  "description": "可選電郵通知功能",
                  "highlight": "讓家長分享每一次解鎖的喜悅"
                },
                {
                  "title": "校外成就申報",
                  "description": "學生上載校外成就及證明",
                  "highlight": "全面記錄學生多元發展"
                },
                {
                  "title": "家長鼓勵功能",
                  "description": "家長可對孩子的成就表達鼓勵",
                  "highlight": "加強家校情感連結"
                }
              ]
            }
          ]
        },
        "cta": {
          "tag": "立即行動",
          "title": "準備好建立品格文化了嗎？",
          "text": "讓我們一起起步 — 歡迎預約示範或索取更多資料。",
          "whatsapp_label": "WhatsApp 聯絡我們",
          "form_label": "填寫聯絡表單",
          "closing": "ValuesIncubator — 讓每一位學生的獨特強項被發掘、被慶祝、被培育。"
        }
      },
      "zh-Hans": {
        "subtitle": "让品格教育可行、切实、具实证 — 全方位家校携手",
        "summary": "以科学实证为基础，打造可测量、可持续的品格教育生态系。",
        "hero_alt": "ValuesIncubator+ 学生端：正面校园与解锁奖卡",
        "blocks": {
          "coreFeaturesTag": "系统核心特色",
          "coreFeaturesTitle": "为何选择 ValuesIncubator+",
          "stakeholdersTag": "为学校带来的价值",
          "stakeholdersTitle": "对每一位持份者的承诺",
          "tableHeaders": {
            "feature": "功能",
            "description": "说明",
            "highlight": "特色",
            "stakeholder": "持份者",
            "value": "价值"
          },
          "coreFeatures": [
            {
              "title": "安全与私隐",
              "text": "学生以班级＋学号识别，无需个人电邮或帐户；教师审阅机制确保报告质素；校长仪表板为唯读权限。"
            },
            {
              "title": "跨平台与语言",
              "text": "流动装置友善的网页体验；繁体中文及英文双语介面；学生内容以输入语言原样储存。"
            },
            {
              "title": "完整报告机制",
              "text": "学生解锁与反思、教师颁发与检视、管理员系统设定、校长唯读影响力仪表板。"
            },
            {
              "title": "科学基础",
              "text": "建基于成长型思维（Carol Dweck），融入强项为本的正向心理学，让品格教育既具吸引力又具实效。"
            }
          ],
          "stakeholders": [
            {
              "role": "学生",
              "value": "获得即时肯定、建立成长档案、培养自我觉察"
            },
            {
              "role": "教师",
              "value": "简化表扬流程、掌握学生进度、融入课堂活动"
            },
            {
              "role": "家长",
              "value": "透明了解子女成长、参与鼓励、家校携手"
            },
            {
              "role": "校长",
              "value": "数据驱动决策、证明教育成效、建立正向校园文化"
            }
          ],
          "modules": [
            {
              "id": "rewards",
              "name": "模组一：动态奖励卡系统",
              "tagline": "从抽象价值到具体成就",
              "intro": "让正面强化即时而有意义，将每一个品格成长的瞬间转化为具体记录。",
              "images": [
                {
                  "media_uuid": "fae4984b-4811-4bec-98ba-f45f2b5a56da",
                  "alt": "学生正面校园首页：解锁奖卡与家长专区",
                  "caption": "学生端：正面校园与解锁奖卡",
                  "width": 763,
                  "height": 849
                },
                {
                  "media_uuid": "41b2d89a-833d-4090-ad68-504e1f9b0c34",
                  "alt": "品格价值管理介面：自订价值、卡面与双语名称",
                  "caption": "管理端：品格价值与卡面设定",
                  "width": 1105,
                  "height": 898
                }
              ],
              "features": [
                {
                  "title": "即时表扬",
                  "description": "教师扫描 QR 码即时颁发奖励卡",
                  "highlight": "即时肯定，强化正面行为"
                },
                {
                  "title": "以学生为本",
                  "description": "流畅且保障私隐的设计",
                  "highlight": "无需电邮或帐户，以班级学号识别"
                },
                {
                  "title": "成长组合",
                  "description": "从奖牌迈向奖杯的进阶机制",
                  "highlight": "轻松愉快建立个人成长档案"
                },
                {
                  "title": "反思与成长",
                  "description": "学生反思表扬内容并记录情绪",
                  "highlight": "培养自我觉察与成长型思维"
                },
                {
                  "title": "家长鼓励",
                  "description": "单一系统连结家长",
                  "highlight": "家校携手共同鼓励学生成长"
                }
              ]
            },
            {
              "id": "admin",
              "name": "模组二：教师与行政管理工具",
              "tagline": "赋能教育工作者，精简行政运作",
              "intro": "为教师和行政人员提供强大而直观的工具，将品格教育无缝融入日常教学。",
              "images": [
                {
                  "media_uuid": "a297c0ca-d2c9-4676-8cc2-a8fbf847c1d9",
                  "alt": "教师管理后台仪表板：库存统计与解锁分析图表",
                  "caption": "管理面板：库存、解锁分析与老师成效",
                  "width": 904,
                  "height": 800
                }
              ],
              "features": [
                {
                  "title": "课堂融入",
                  "description": "教师管理虚拟奖励卡",
                  "highlight": "可建立与价值观相关的课堂活动"
                },
                {
                  "title": "全面掌控",
                  "description": "完整追踪奖励卡生命周期",
                  "highlight": "从库存到分发，确保计划贯彻执行"
                },
                {
                  "title": "弹性自订",
                  "description": "自订品格价值清单",
                  "highlight": "根据学校独特理念设定如「勇气」、「同理心」等价值"
                },
                {
                  "title": "批量管理",
                  "description": "CSV 汇入汇出、QR 码批量列印",
                  "highlight": "节省行政时间，提升效率"
                }
              ]
            },
            {
              "id": "analytics",
              "name": "模组三：数据分析与 AI 报告",
              "tagline": "数据的力量：见证您启发的成长",
              "intro": "衡量真正重要的事，提供洞察以展现教育影响力。",
              "images": [],
              "features": [
                {
                  "title": "360 度全方位视角",
                  "description": "汇集学生、教师和家长的多元回馈",
                  "highlight": "全面掌握学生发展状况"
                },
                {
                  "title": "AI 生成报告",
                  "description": "将解锁纪录转化为个人化叙事报告",
                  "highlight": "教师审阅后方可释出，确保质素"
                },
                {
                  "title": "校长仪表板",
                  "description": "全校影响力唯读仪表板",
                  "highlight": "宏观掌握计划成效"
                },
                {
                  "title": "趋势分析",
                  "description": "CSV 汇出与数据分析功能",
                  "highlight": "协助优化策略并证明教育成效"
                },
                {
                  "title": "奖章与奖牌计划",
                  "description": "自订奖励计划及达标门槛",
                  "highlight": "多元化激励机制"
                }
              ]
            },
            {
              "id": "community",
              "name": "模组四：家校社群连结",
              "tagline": "建立紧密连结的社群",
              "intro": "品格发展跨越校园，连结家庭，建构完整的正向教育生态。",
              "images": [
                {
                  "media_uuid": "d6c27aa3-acd5-499b-ae33-5fbbd7ee79df",
                  "alt": "成就页面：奖章等级与达标计划进度",
                  "caption": "成就与奖章计划进度",
                  "width": 599,
                  "height": 820
                },
                {
                  "media_uuid": "624b1e32-06e1-4045-84b1-64bf8e15e451",
                  "alt": "学生／家长总览：解锁纪录与成就标签",
                  "caption": "总览：最近解锁与家校同步",
                  "width": 484,
                  "height": 830
                }
              ],
              "features": [
                {
                  "title": "家长入口网站",
                  "description": "安全的专属平台",
                  "highlight": "展示孩子的进度、解锁纪录与报告"
                },
                {
                  "title": "即时通知",
                  "description": "可选电邮通知功能",
                  "highlight": "让家长分享每一次解锁的喜悦"
                },
                {
                  "title": "校外成就申报",
                  "description": "学生上载校外成就及证明",
                  "highlight": "全面记录学生多元发展"
                },
                {
                  "title": "家长鼓励功能",
                  "description": "家长可对孩子的成就表达鼓励",
                  "highlight": "加强家校情感连结"
                }
              ]
            }
          ]
        },
        "cta": {
          "tag": "立即行动",
          "title": "准备好建立品格文化了吗？",
          "text": "让我们一起起步 — 欢迎预约示范或索取更多资料。",
          "whatsapp_label": "WhatsApp 联络我们",
          "form_label": "填写联络表单",
          "closing": "ValuesIncubator — 让每一位学生的独特强项被发掘、被庆祝、被培育。"
        }
      },
      "en": {
        "subtitle": "Making character education practical, evidence-based, and fully home–school connected",
        "summary": "A science-based, measurable, and sustainable character-education ecosystem.",
        "hero_alt": "ValuesIncubator+ student view: positive campus and unlocked cards",
        "blocks": {
          "coreFeaturesTag": "System Core Features",
          "coreFeaturesTitle": "Why ValuesIncubator+",
          "stakeholdersTag": "Value for Schools",
          "stakeholdersTitle": "A Promise to Every Stakeholder",
          "tableHeaders": {
            "feature": "Feature",
            "description": "Description",
            "highlight": "Highlight",
            "stakeholder": "Stakeholder",
            "value": "Value"
          },
          "coreFeatures": [
            {
              "title": "Safety & Privacy",
              "text": "Students identified by class + student number — no email or account needed; teacher review gates AI report release; principal dashboard is read-only."
            },
            {
              "title": "Cross-platform & Bilingual",
              "text": "Mobile-friendly web experience; traditional Chinese and English interface; student input stored verbatim in the original language."
            },
            {
              "title": "Complete Reporting",
              "text": "Student unlocks and reflections, teacher awards and reviews, admin system settings, and a read-only principal impact dashboard."
            },
            {
              "title": "Science-based",
              "text": "Built on growth mindset (Carol Dweck) and strengths-based positive psychology — engaging and effective."
            }
          ],
          "stakeholders": [
            {
              "role": "Students",
              "value": "Instant affirmation, growth portfolio, self-awareness"
            },
            {
              "role": "Teachers",
              "value": "Simplified recognition, progress visibility, classroom integration"
            },
            {
              "role": "Parents",
              "value": "Transparent view of growth, active encouragement, home–school partnership"
            },
            {
              "role": "Principals",
              "value": "Data-driven decisions, evidenced outcomes, positive school culture"
            }
          ],
          "modules": [
            {
              "id": "rewards",
              "name": "Module 1: Dynamic Reward Card System",
              "tagline": "From abstract values to concrete achievement",
              "intro": "Positive reinforcement made immediate and meaningful — every growth moment becomes a tangible record.",
              "images": [
                {
                  "media_uuid": "fae4984b-4811-4bec-98ba-f45f2b5a56da",
                  "alt": "Student home view: unlockable reward cards and parent zone",
                  "caption": "Student view: positive campus & unlocked cards",
                  "width": 763,
                  "height": 849
                },
                {
                  "media_uuid": "41b2d89a-833d-4090-ad68-504e1f9b0c34",
                  "alt": "Character value admin: custom values, card faces and bilingual names",
                  "caption": "Admin: character values and card-face setup",
                  "width": 1105,
                  "height": 898
                }
              ],
              "features": [
                {
                  "title": "Instant Recognition",
                  "description": "Teachers scan a QR code to issue cards on the spot",
                  "highlight": "Immediate affirmation reinforces positive behaviour"
                },
                {
                  "title": "Student-first Design",
                  "description": "Streamlined, privacy-respecting flow",
                  "highlight": "No email or account needed — class + student number"
                },
                {
                  "title": "Growth Bundles",
                  "description": "Progression from badges to trophies",
                  "highlight": "Build personal growth portfolios with ease"
                },
                {
                  "title": "Reflect & Grow",
                  "description": "Students reflect on each recognition and log emotions",
                  "highlight": "Cultivates self-awareness and growth mindset"
                },
                {
                  "title": "Parental Encouragement",
                  "description": "One system keeps parents in the loop",
                  "highlight": "Home–school partners in encouragement"
                }
              ]
            },
            {
              "id": "admin",
              "name": "Module 2: Teacher & Admin Tools",
              "tagline": "Empowering educators, simplifying admin",
              "intro": "Powerful and intuitive tools that let teachers and admins fold character education into daily teaching.",
              "images": [
                {
                  "media_uuid": "a297c0ca-d2c9-4676-8cc2-a8fbf847c1d9",
                  "alt": "Teacher admin dashboard: inventory stats and unlock analytics charts",
                  "caption": "Admin panel: inventory, unlock analytics and teacher impact",
                  "width": 904,
                  "height": 800
                }
              ],
              "features": [
                {
                  "title": "Classroom Integration",
                  "description": "Teachers manage virtual reward cards",
                  "highlight": "Build values-linked classroom activities"
                },
                {
                  "title": "Full Control",
                  "description": "Track reward card lifecycle end-to-end",
                  "highlight": "From inventory to distribution — fidelity assured"
                },
                {
                  "title": "Flexible Customisation",
                  "description": "Define your own character-value list",
                  "highlight": "Set 'Courage', 'Empathy' and more to match school ethos"
                },
                {
                  "title": "Bulk Management",
                  "description": "CSV import/export, bulk QR printing",
                  "highlight": "Save admin time, lift efficiency"
                }
              ]
            },
            {
              "id": "analytics",
              "name": "Module 3: Analytics & AI Reports",
              "tagline": "The power of data: see the growth you inspire",
              "intro": "Measure what truly matters — surface the insight that proves educational impact.",
              "images": [],
              "features": [
                {
                  "title": "360° View",
                  "description": "Multi-source feedback from students, teachers and parents",
                  "highlight": "Holistic view of student development"
                },
                {
                  "title": "AI-Generated Reports",
                  "description": "Convert unlock records into personalised narrative reports",
                  "highlight": "Teacher review gates release for quality"
                },
                {
                  "title": "Principal Dashboard",
                  "description": "School-wide impact dashboard, read-only",
                  "highlight": "Bird's-eye view of programme effectiveness"
                },
                {
                  "title": "Trend Analysis",
                  "description": "CSV export and data-analysis features",
                  "highlight": "Refine strategy and evidence outcomes"
                },
                {
                  "title": "Badges & Medallions",
                  "description": "Custom reward programmes and milestones",
                  "highlight": "Multiple motivation pathways"
                }
              ]
            },
            {
              "id": "community",
              "name": "Module 4: Home–School Community",
              "tagline": "Building a tightly-knit community",
              "intro": "Character growth extends past the campus — connecting families for a complete positive-education ecology.",
              "images": [
                {
                  "media_uuid": "d6c27aa3-acd5-499b-ae33-5fbbd7ee79df",
                  "alt": "Achievements page: badge tiers and milestone progress",
                  "caption": "Achievements and badge-plan progress",
                  "width": 599,
                  "height": 820
                },
                {
                  "media_uuid": "624b1e32-06e1-4045-84b1-64bf8e15e451",
                  "alt": "Student / parent overview: unlock records and achievement tags",
                  "caption": "Overview: recent unlocks and home–school sync",
                  "width": 484,
                  "height": 830
                }
              ],
              "features": [
                {
                  "title": "Parent Portal",
                  "description": "Secure, dedicated platform",
                  "highlight": "Shows child's progress, unlocks and reports"
                },
                {
                  "title": "Instant Notifications",
                  "description": "Optional email notifications",
                  "highlight": "Parents share every unlock moment"
                },
                {
                  "title": "Off-campus Submissions",
                  "description": "Students upload outside achievements and proof",
                  "highlight": "Captures the full development picture"
                },
                {
                  "title": "Parent Encouragement",
                  "description": "Parents can react to their child's achievements",
                  "highlight": "Strengthens home–school emotional bonds"
                }
              ]
            }
          ]
        },
        "cta": {
          "tag": "Take Action",
          "title": "Ready to build a culture of character?",
          "text": "Let's start together — book a demo or request more information.",
          "whatsapp_label": "WhatsApp us",
          "form_label": "Fill the contact form",
          "closing": "ValuesIncubator — every student's unique strengths are seen, celebrated, and nurtured."
        }
      }
    }
  },
  {
    "product_slug": "harbour",
    "layout_kind": "harbour",
    "subtitle": "一個讓學生被真正認識的安全之所。",
    "summary": "Harbour 是一個為中學而設的雙語性格強項與牧養關懷平台。它將日常的認可與日常的關懷，轉化為每位學生成長歷程中一以貫之的故事——並守護支撐這段旅程的信任關係。",
    "hero_media_id": null,
    "hero_uuid": null,
    "hero_alt": "",
    "blocks": {
      "hero": {
        "tag": "看見．命名．培育",
        "title": "My Harbour 我的海灣",
        "description": "Harbour 是一個為中學而設的雙語性格強項與牧養關懷平台。它將日常的認可與日常的關懷，轉化為每位學生成長歷程中一以貫之的故事——並守護支撐這段旅程的信任關係。",
        "subtitle": "一個讓學生被真正認識的安全之所。",
        "ctaPrimary": "預約示範",
        "ctaSecondary": "了解運作"
      },
      "problem": {
        "tag": "問題所在",
        "title": "一宗個案也嫌多。",
        "intro": "我們聽過太多關於年輕人感到求助無門的故事。學校並非漠不關心——然而，僅存在於記憶中、閒談之間與紙張筆記上的關懷，無法在全校規模上守護每一位學生。",
        "bullets": [
          "認可稍縱即逝，未及成為記錄。 教師察覺到學生的成長片刻，但若沒有記錄，它便會消失——在報告中看不見，在歲月中看不見，在學生自己的故事中也看不見。",
          "牧養訊號分散於不同教職員與系統之間。 一位教師看見同學退縮，另一位看見不吃午餐，第三位看見成績下滑。沒有人看見整體的模式。",
          "關係是在平靜時刻建立的，而非危機時刻。 正如例行身體檢查，是定期、低調的 Check-In 建立信任，使我們能夠及早察覺變化——並在關鍵時刻坦誠對話。若關係在危機時刻建立，那已經太遲。",
          "家長與學校各自只掌握一半的面貌。 教師在課室所見的，與家長在家中所見的，是同一個故事的兩半。若缺乏持續的雙向交流，雙方都只能憑片面的理解行事——而學生則在兩個割裂的世界之間獨自穿梭。"
        ]
      },
      "beliefs": {
        "tag": "我們的信念",
        "title": "我們相信什麼",
        "items": [
          {
            "title": "連結必須是恆常的——而非僅限於危機時刻。",
            "text": "關係是耕耘出來的，而非狩獵得來的。良好的關係從來不是單次介入的結果；它是在持續不斷、日常被看見的時刻中慢慢滋長。正如例行身體檢查，定期 Check-In 是預防性的關懷——它們建立信任與熟悉感，使我們能夠及早察覺變化，遠在擔憂演變成危機之前。"
          },
          {
            "title": "年輕人需要在受信任的環境中感到被支持。",
            "text": "支持唯有在安全、私密且保有尊嚴的情況下才能奏效。信任是先決條件——而非回報。當關係早已存在，學生遠更願意坦誠傾訴；若關係是因問題才被召喚出來，則難以奏效。"
          },
          {
            "title": "科技應在規模上支援人的工作。",
            "text": "一位教師可以憑記憶維繫數段關係；一所學校卻無法。科技應承載記憶、浮現訊號，並守護教師所需的時間，讓他們得以專注於人的片刻——使每一份認可都不會流失，每一個模式都不會被忽略。"
          },
          {
            "title": "家長與學校是學生關懷中的平等夥伴。",
            "text": "學生的旅程由家庭與學校共同塑造——而任何一方都無法獨自掌握全貌。家長並非被動接收資訊的觀眾，而是關懷關係的共同擁有者。當雙方持續雙向分享所見，學生便會被一個一致而連貫的網絡所承托，而非在兩個割裂的世界之間徘徊。"
          },
          {
            "title": "關懷必須是持續的，而非零散的。",
            "text": "單一次對話，無論出於多麼良好的意願，都無法支撐學生走過整個校園歲月。關懷必須是一種穩定的節奏——看得見、有記錄、可重訪——讓每位學生在時間中被認識，而不僅是在困難時刻。正是這份持續性，將零散的善意轉化為一段關於學生成為誰的一以貫之的故事。"
          }
        ]
      },
      "design": {
        "tag": "設計哲學",
        "title": "強項為先。教師為本。學生安全。AI 輔助。",
        "intro": "每一項功能都必須通過一項測試：",
        "test": "「這是否能深化真誠的人際連結與正向品格成長，並提供牧養關懷？」",
        "closing": "若不能，便不推出。"
      },
      "vision": {
        "tag": "產品願景",
        "title": "一個平台，一個成長故事。",
        "intro": "一個平台，讓每位教師都能察覺、命名、培育學生的性格強項——並讓每位學生都被認識、被支持，且擁有一段關於自己正在成為誰的一以貫之的故事。",
        "pillars": [
          "只有一個儀表板。一份學生存檔。一個提示佇列。一個報告層。讚賞與關懷並非各自獨立——學生在失望的時刻需要鼓勵，正如在成就的時刻一樣。兩個關鍵時刻，都在同一個關係平台中獲得支援。",
          "這是唯一能賦權教育工作者與學生建立關係的方案——既能培育成功，也能擁抱失敗。"
        ]
      },
      "how": {
        "tag": "運作方式",
        "title": "觀察 → 主動接觸 → 接收 → 自主舒緩 → 專業輔導 → 持續跟進",
        "intro": "一段牧養關懷的歷程，由教師的首次觀察開始，逐步建立一段值得信賴的關係，全程陪伴學生。",
        "steps": [
          {
            "title": "觀察與認可",
            "text": "流程始於教師的專注觀察。透過刻意的陪伴與辨識，教師識別學生的掙扎跡象、行為轉變或正在浮現的需要。"
          },
          {
            "title": "主動接觸",
            "text": "無論學生是否選擇傾訴心事，教師都會主動表達支持——例如送上一張載有個人化鼓勵與關懷訊息的卡片——以傳達學生被看見、被重視的訊息。"
          },
          {
            "title": "接收與反思",
            "text": "學生接收並內化這份關懷的表達。是次互動隨後會被記錄於系統之中，引發結構化反思，並確保關懷得以延續。"
          },
          {
            "title": "個人化支援與復元",
            "text": "在安全而舒適的環境中，學生透過系統獲取個人化的牧養關懷訊息。這讓學生能夠在沒有過度壓力或焦慮的情況下，自主地獲得舒緩與情緒調節。"
          },
          {
            "title": "專業輔導",
            "text": "系統可與 OpenUp 無縫整合，以提供專業輔導服務。學生在需要時，能夠安心且信任地獲得合資格的專業支援。"
          },
          {
            "title": "持續跟進與關係建立",
            "text": "教師再次與學生接觸，鞏固關係並加深信任。每一次互動都為持續演進的記錄增添內容，確保關懷隨著時間保持一致、知情且適切回應。"
          }
        ]
      },
      "features": {
        "tag": "功能",
        "title": "認可層與牧養關懷層",
        "recognition": {
          "title": "察覺並命名美好之處",
          "items": [
            {
              "title": "美德與價值卡",
              "text": "以雙語名稱及卡面藝術定義學校的性格價值。印製專屬二維碼卡、管理庫存、分配予教師，並追蹤每一次解鎖。"
            },
            {
              "title": "學生快速解鎖",
              "text": "學生掃描、僅以班別及學號識別，並撰寫簡短反思。領取卡片無需註冊帳戶。"
            },
            {
              "title": "性格檔案",
              "text": "解鎖記錄累積成可列印的檔案，並附有成就獎章。校外成就亦可提交，由教師核實。"
            },
            {
              "title": "性格報告",
              "text": "根據多年來的真實證據生成。教師審閱並發佈；學生與家長僅可查看已獲批准的報告。"
            }
          ]
        },
        "pastoral": {
          "title": "在關鍵時刻察覺並回應",
          "items": [
            {
              "title": "Check-In 訊息",
              "text": "AI 協助策劃簡短、溫和的 Check-In 訊息予學生——是一份關懷的問候，而非召喚。"
            },
            {
              "title": "牧養關懷類型",
              "text": "定義學校提供的關懷種類——學業、情緒、社交、家庭、行為、靈性——並附雙語名稱。"
            },
            {
              "title": "關懷記錄",
              "text": "每一次 Check-In 都成為學生的關懷紀錄的一部分——讓模式得以浮現，跟進有據可依，而非憑空猜測。"
            },
            {
              "title": "提示佇列",
              "text": "當學生發出困擾訊號或模式出現轉變時，合適的教職員會及早獲通知——而非在危機之後。"
            },
            {
              "title": "教職員權限",
              "text": "班主任、輔導員及牧養主管各取所需——權限設定保障學生的尊嚴。"
            }
          ]
        }
      },
      "ai": {
        "tag": "一個平台，一份記錄",
        "title": "教師主導，AI 輔助",
        "intro": "AI 負責記憶。教師負責連結。",
        "bullets": [
          "浮現學生卡片、反思與 Check-In 之間的模式",
          "根據真實證據起草性格報告——但從不自行發佈",
          "標示語氣或參與度的變化，供人手審閱",
          "從不取代教師的判斷，亦從不直接聯絡學生"
        ],
        "gate": "教師發佈關卡：每一份報告、每一個提示、每一次家庭通訊，都必須經過人手處理。"
      },
      "principles": {
        "tag": "信任與設計原則",
        "title": "我們如何贏得信任",
        "items": [
          {
            "title": "以強項為本，絕不懲罰",
            "text": "認可與關懷——沒有扣分，沒有懲罰追蹤。"
          },
          {
            "title": "學生安全為預設",
            "text": "私密、獲授權、保有尊嚴。學生被看見，而非被監視。反思與回應保持原樣——不強制翻譯。"
          },
          {
            "title": "手機友善",
            "text": "為手機而設——在走廊、在課室、在輔導室。"
          },
          {
            "title": "學校品牌",
            "text": "你的價值、你的卡面藝術、你的身份。"
          }
        ]
      },
      "who": {
        "tag": "適合誰使用",
        "title": "為學校每一個角色而設",
        "intro": "一個平台，一份記錄——多種使用方式。",
        "rows": [
          {
            "role": "校長",
            "gets": "全校性格與關懷文化的實證"
          },
          {
            "role": "教師",
            "gets": "數秒內察覺、行動、跟進——系統保留記錄"
          },
          {
            "role": "輔導員／牧養主管",
            "gets": "清晰的關懷紀錄、及早提示、模式而非猜測"
          },
          {
            "role": "學生",
            "gets": "掃描、反思、成長——並被問及你真正過得如何"
          },
          {
            "role": "家長",
            "gets": "看見強項與關懷，無需另一個複雜的登入"
          }
        ]
      },
      "northStar": {
        "tag": "我們的北極星",
        "quote": "每位學生離開中學時，都帶著一段關於自己正在成為誰的一以貫之、以強項為本的故事——以及至少一段支撐這段旅程的信任成人關係。"
      },
      "next": {
        "tag": "下一步",
        "title": "準備好見證 Harbour 的實際運作了嗎？",
        "options": [
          "即時示範導覽",
          "為你的學校而設的試行計劃",
          "與團隊問答交流"
        ],
        "ctaPrimary": "預約示範",
        "ctaSecondary": "聯絡團隊"
      }
    },
    "cta": {
      "tag": "",
      "title": "",
      "text": "",
      "whatsapp_label": "",
      "form_label": "",
      "closing": ""
    },
    "locales": {
      "zh-Hant": {
        "subtitle": "一個讓學生被真正認識的安全之所。",
        "summary": "Harbour 是一個為中學而設的雙語性格強項與牧養關懷平台。它將日常的認可與日常的關懷，轉化為每位學生成長歷程中一以貫之的故事——並守護支撐這段旅程的信任關係。",
        "hero_alt": "",
        "blocks": {
          "hero": {
            "tag": "看見．命名．培育",
            "title": "My Harbour 我的海灣",
            "description": "Harbour 是一個為中學而設的雙語性格強項與牧養關懷平台。它將日常的認可與日常的關懷，轉化為每位學生成長歷程中一以貫之的故事——並守護支撐這段旅程的信任關係。",
            "subtitle": "一個讓學生被真正認識的安全之所。",
            "ctaPrimary": "預約示範",
            "ctaSecondary": "了解運作"
          },
          "problem": {
            "tag": "問題所在",
            "title": "一宗個案也嫌多。",
            "intro": "我們聽過太多關於年輕人感到求助無門的故事。學校並非漠不關心——然而，僅存在於記憶中、閒談之間與紙張筆記上的關懷，無法在全校規模上守護每一位學生。",
            "bullets": [
              "認可稍縱即逝，未及成為記錄。 教師察覺到學生的成長片刻，但若沒有記錄，它便會消失——在報告中看不見，在歲月中看不見，在學生自己的故事中也看不見。",
              "牧養訊號分散於不同教職員與系統之間。 一位教師看見同學退縮，另一位看見不吃午餐，第三位看見成績下滑。沒有人看見整體的模式。",
              "關係是在平靜時刻建立的，而非危機時刻。 正如例行身體檢查，是定期、低調的 Check-In 建立信任，使我們能夠及早察覺變化——並在關鍵時刻坦誠對話。若關係在危機時刻建立，那已經太遲。",
              "家長與學校各自只掌握一半的面貌。 教師在課室所見的，與家長在家中所見的，是同一個故事的兩半。若缺乏持續的雙向交流，雙方都只能憑片面的理解行事——而學生則在兩個割裂的世界之間獨自穿梭。"
            ]
          },
          "beliefs": {
            "tag": "我們的信念",
            "title": "我們相信什麼",
            "items": [
              {
                "title": "連結必須是恆常的——而非僅限於危機時刻。",
                "text": "關係是耕耘出來的，而非狩獵得來的。良好的關係從來不是單次介入的結果；它是在持續不斷、日常被看見的時刻中慢慢滋長。正如例行身體檢查，定期 Check-In 是預防性的關懷——它們建立信任與熟悉感，使我們能夠及早察覺變化，遠在擔憂演變成危機之前。"
              },
              {
                "title": "年輕人需要在受信任的環境中感到被支持。",
                "text": "支持唯有在安全、私密且保有尊嚴的情況下才能奏效。信任是先決條件——而非回報。當關係早已存在，學生遠更願意坦誠傾訴；若關係是因問題才被召喚出來，則難以奏效。"
              },
              {
                "title": "科技應在規模上支援人的工作。",
                "text": "一位教師可以憑記憶維繫數段關係；一所學校卻無法。科技應承載記憶、浮現訊號，並守護教師所需的時間，讓他們得以專注於人的片刻——使每一份認可都不會流失，每一個模式都不會被忽略。"
              },
              {
                "title": "家長與學校是學生關懷中的平等夥伴。",
                "text": "學生的旅程由家庭與學校共同塑造——而任何一方都無法獨自掌握全貌。家長並非被動接收資訊的觀眾，而是關懷關係的共同擁有者。當雙方持續雙向分享所見，學生便會被一個一致而連貫的網絡所承托，而非在兩個割裂的世界之間徘徊。"
              },
              {
                "title": "關懷必須是持續的，而非零散的。",
                "text": "單一次對話，無論出於多麼良好的意願，都無法支撐學生走過整個校園歲月。關懷必須是一種穩定的節奏——看得見、有記錄、可重訪——讓每位學生在時間中被認識，而不僅是在困難時刻。正是這份持續性，將零散的善意轉化為一段關於學生成為誰的一以貫之的故事。"
              }
            ]
          },
          "design": {
            "tag": "設計哲學",
            "title": "強項為先。教師為本。學生安全。AI 輔助。",
            "intro": "每一項功能都必須通過一項測試：",
            "test": "「這是否能深化真誠的人際連結與正向品格成長，並提供牧養關懷？」",
            "closing": "若不能，便不推出。"
          },
          "vision": {
            "tag": "產品願景",
            "title": "一個平台，一個成長故事。",
            "intro": "一個平台，讓每位教師都能察覺、命名、培育學生的性格強項——並讓每位學生都被認識、被支持，且擁有一段關於自己正在成為誰的一以貫之的故事。",
            "pillars": [
              "只有一個儀表板。一份學生存檔。一個提示佇列。一個報告層。讚賞與關懷並非各自獨立——學生在失望的時刻需要鼓勵，正如在成就的時刻一樣。兩個關鍵時刻，都在同一個關係平台中獲得支援。",
              "這是唯一能賦權教育工作者與學生建立關係的方案——既能培育成功，也能擁抱失敗。"
            ]
          },
          "how": {
            "tag": "運作方式",
            "title": "觀察 → 主動接觸 → 接收 → 自主舒緩 → 專業輔導 → 持續跟進",
            "intro": "一段牧養關懷的歷程，由教師的首次觀察開始，逐步建立一段值得信賴的關係，全程陪伴學生。",
            "steps": [
              {
                "title": "觀察與認可",
                "text": "流程始於教師的專注觀察。透過刻意的陪伴與辨識，教師識別學生的掙扎跡象、行為轉變或正在浮現的需要。"
              },
              {
                "title": "主動接觸",
                "text": "無論學生是否選擇傾訴心事，教師都會主動表達支持——例如送上一張載有個人化鼓勵與關懷訊息的卡片——以傳達學生被看見、被重視的訊息。"
              },
              {
                "title": "接收與反思",
                "text": "學生接收並內化這份關懷的表達。是次互動隨後會被記錄於系統之中，引發結構化反思，並確保關懷得以延續。"
              },
              {
                "title": "個人化支援與復元",
                "text": "在安全而舒適的環境中，學生透過系統獲取個人化的牧養關懷訊息。這讓學生能夠在沒有過度壓力或焦慮的情況下，自主地獲得舒緩與情緒調節。"
              },
              {
                "title": "專業輔導",
                "text": "系統可與 OpenUp 無縫整合，以提供專業輔導服務。學生在需要時，能夠安心且信任地獲得合資格的專業支援。"
              },
              {
                "title": "持續跟進與關係建立",
                "text": "教師再次與學生接觸，鞏固關係並加深信任。每一次互動都為持續演進的記錄增添內容，確保關懷隨著時間保持一致、知情且適切回應。"
              }
            ]
          },
          "features": {
            "tag": "功能",
            "title": "認可層與牧養關懷層",
            "recognition": {
              "title": "察覺並命名美好之處",
              "items": [
                {
                  "title": "美德與價值卡",
                  "text": "以雙語名稱及卡面藝術定義學校的性格價值。印製專屬二維碼卡、管理庫存、分配予教師，並追蹤每一次解鎖。"
                },
                {
                  "title": "學生快速解鎖",
                  "text": "學生掃描、僅以班別及學號識別，並撰寫簡短反思。領取卡片無需註冊帳戶。"
                },
                {
                  "title": "性格檔案",
                  "text": "解鎖記錄累積成可列印的檔案，並附有成就獎章。校外成就亦可提交，由教師核實。"
                },
                {
                  "title": "性格報告",
                  "text": "根據多年來的真實證據生成。教師審閱並發佈；學生與家長僅可查看已獲批准的報告。"
                }
              ]
            },
            "pastoral": {
              "title": "在關鍵時刻察覺並回應",
              "items": [
                {
                  "title": "Check-In 訊息",
                  "text": "AI 協助策劃簡短、溫和的 Check-In 訊息予學生——是一份關懷的問候，而非召喚。"
                },
                {
                  "title": "牧養關懷類型",
                  "text": "定義學校提供的關懷種類——學業、情緒、社交、家庭、行為、靈性——並附雙語名稱。"
                },
                {
                  "title": "關懷記錄",
                  "text": "每一次 Check-In 都成為學生的關懷紀錄的一部分——讓模式得以浮現，跟進有據可依，而非憑空猜測。"
                },
                {
                  "title": "提示佇列",
                  "text": "當學生發出困擾訊號或模式出現轉變時，合適的教職員會及早獲通知——而非在危機之後。"
                },
                {
                  "title": "教職員權限",
                  "text": "班主任、輔導員及牧養主管各取所需——權限設定保障學生的尊嚴。"
                }
              ]
            }
          },
          "ai": {
            "tag": "一個平台，一份記錄",
            "title": "教師主導，AI 輔助",
            "intro": "AI 負責記憶。教師負責連結。",
            "bullets": [
              "浮現學生卡片、反思與 Check-In 之間的模式",
              "根據真實證據起草性格報告——但從不自行發佈",
              "標示語氣或參與度的變化，供人手審閱",
              "從不取代教師的判斷，亦從不直接聯絡學生"
            ],
            "gate": "教師發佈關卡：每一份報告、每一個提示、每一次家庭通訊，都必須經過人手處理。"
          },
          "principles": {
            "tag": "信任與設計原則",
            "title": "我們如何贏得信任",
            "items": [
              {
                "title": "以強項為本，絕不懲罰",
                "text": "認可與關懷——沒有扣分，沒有懲罰追蹤。"
              },
              {
                "title": "學生安全為預設",
                "text": "私密、獲授權、保有尊嚴。學生被看見，而非被監視。反思與回應保持原樣——不強制翻譯。"
              },
              {
                "title": "手機友善",
                "text": "為手機而設——在走廊、在課室、在輔導室。"
              },
              {
                "title": "學校品牌",
                "text": "你的價值、你的卡面藝術、你的身份。"
              }
            ]
          },
          "who": {
            "tag": "適合誰使用",
            "title": "為學校每一個角色而設",
            "intro": "一個平台，一份記錄——多種使用方式。",
            "rows": [
              {
                "role": "校長",
                "gets": "全校性格與關懷文化的實證"
              },
              {
                "role": "教師",
                "gets": "數秒內察覺、行動、跟進——系統保留記錄"
              },
              {
                "role": "輔導員／牧養主管",
                "gets": "清晰的關懷紀錄、及早提示、模式而非猜測"
              },
              {
                "role": "學生",
                "gets": "掃描、反思、成長——並被問及你真正過得如何"
              },
              {
                "role": "家長",
                "gets": "看見強項與關懷，無需另一個複雜的登入"
              }
            ]
          },
          "northStar": {
            "tag": "我們的北極星",
            "quote": "每位學生離開中學時，都帶著一段關於自己正在成為誰的一以貫之、以強項為本的故事——以及至少一段支撐這段旅程的信任成人關係。"
          },
          "next": {
            "tag": "下一步",
            "title": "準備好見證 Harbour 的實際運作了嗎？",
            "options": [
              "即時示範導覽",
              "為你的學校而設的試行計劃",
              "與團隊問答交流"
            ],
            "ctaPrimary": "預約示範",
            "ctaSecondary": "聯絡團隊"
          }
        },
        "cta": {
          "tag": "",
          "title": "",
          "text": "",
          "whatsapp_label": "",
          "form_label": "",
          "closing": ""
        }
      },
      "zh-Hans": {
        "subtitle": "一个让学生被真正认识的安全之所。",
        "summary": "Harbour 是一个为中学而设的双语性格强项与牧养关怀平台。它将日常的认可与日常的关怀，转化为每位学生成长历程中一以贯之的故事——并守护支撑这段旅程的信任关系。",
        "hero_alt": "",
        "blocks": {
          "hero": {
            "tag": "看见．命名．培育",
            "title": "My Harbour 我的海湾",
            "description": "Harbour 是一个为中学而设的双语性格强项与牧养关怀平台。它将日常的认可与日常的关怀，转化为每位学生成长历程中一以贯之的故事——并守护支撑这段旅程的信任关系。",
            "subtitle": "一个让学生被真正认识的安全之所。",
            "ctaPrimary": "预约示范",
            "ctaSecondary": "了解运作"
          },
          "problem": {
            "tag": "问题所在",
            "title": "一宗个案也嫌多。",
            "intro": "我们听过太多关于年轻人感到求助无门的故事。学校并非漠不关心——然而，仅存在于记忆中、闲谈之间与纸张笔记上的关怀，无法在全校规模上守护每一位学生。",
            "bullets": [
              "认可稍纵即逝，未及成为记录。 教师察觉到学生的成长片刻，但若没有记录，它便会消失——在报告中看不见，在岁月中看不见，在学生自己的故事中也看不见。",
              "牧养讯号分散于不同教职员与系统之间。 一位教师看见同学退缩，另一位看见不吃午餐，第三位看见成绩下滑。没有人看见整体的模式。",
              "关系是在平静时刻建立的，而非危机时刻。 正如例行身体检查，是定期、低调的 Check-In 建立信任，使我们能够及早察觉变化——并在关键时刻坦诚对话。若关系在危机时刻建立，那已经太迟。",
              "家长与学校各自只掌握一半的面貌。 教师在课室所见的，与家长在家中所见的，是同一个故事的两半。若缺乏持续的双向交流，双方都只能凭片面的理解行事——而学生则在两个割裂的世界之间独自穿梭。"
            ]
          },
          "beliefs": {
            "tag": "我们的信念",
            "title": "我们相信什么",
            "items": [
              {
                "title": "连结必须是恒常的——而非仅限于危机时刻。",
                "text": "关系是耕耘出来的，而非狩猎得来的。良好的关系从来不是单次介入的结果；它是在持续不断、日常被看见的时刻中慢慢滋长。正如例行身体检查，定期 Check-In 是预防性的关怀——它们建立信任与熟悉感，使我们能够及早察觉变化，远在担忧演变成危机之前。"
              },
              {
                "title": "年轻人需要在受信任的环境中感到被支持。",
                "text": "支持唯有在安全、私密且保有尊严的情况下才能奏效。信任是先决条件——而非回报。当关系早已存在，学生远更愿意坦诚倾诉；若关系是因问题才被召唤出来，则难以奏效。"
              },
              {
                "title": "科技应在规模上支援人的工作。",
                "text": "一位教师可以凭记忆维系数段关系；一所学校却无法。科技应承载记忆、浮现讯号，并守护教师所需的时间，让他们得以专注于人的片刻——使每一份认可都不会流失，每一个模式都不会被忽略。"
              },
              {
                "title": "家长与学校是学生关怀中的平等伙伴。",
                "text": "学生的旅程由家庭与学校共同塑造——而任何一方都无法独自掌握全貌。家长并非被动接收资讯的观众，而是关怀关系的共同拥有者。当双方持续双向分享所见，学生便会被一个一致而连贯的网络所承托，而非在两个割裂的世界之间徘徊。"
              },
              {
                "title": "关怀必须是持续的，而非零散的。",
                "text": "单一次对话，无论出于多么良好的意愿，都无法支撑学生走过整个校园岁月。关怀必须是一种稳定的节奏——看得见、有记录、可重访——让每位学生在时间中被认识，而不仅是在困难时刻。正是这份持续性，将零散的善意转化为一段关于学生成为谁的一以贯之的故事。"
              }
            ]
          },
          "design": {
            "tag": "设计哲学",
            "title": "强项为先。教师为本。学生安全。AI 辅助。",
            "intro": "每一项功能都必须通过一项测试：",
            "test": "「这是否能深化真诚的人际连结与正向品格成长，并提供牧养关怀？」",
            "closing": "若不能，便不推出。"
          },
          "vision": {
            "tag": "产品愿景",
            "title": "一个平台，一个成长故事。",
            "intro": "一个平台，让每位教师都能察觉、命名、培育学生的性格强项——并让每位学生都被认识、被支持，且拥有一段关于自己正在成为谁的一以贯之的故事。",
            "pillars": [
              "只有一个仪表板。一份学生存档。一个提示伫列。一个报告层。赞赏与关怀并非各自独立——学生在失望的时刻需要鼓励，正如在成就的时刻一样。两个关键时刻，都在同一个关系平台中获得支援。",
              "这是唯一能赋权教育工作者与学生建立关系的方案——既能培育成功，也能拥抱失败。"
            ]
          },
          "how": {
            "tag": "运作方式",
            "title": "观察 → 主动接触 → 接收 → 自主舒缓 → 专业辅导 → 持续跟进",
            "intro": "一段牧养关怀的历程，由教师的首次观察开始，逐步建立一段值得信赖的关系，全程陪伴学生。",
            "steps": [
              {
                "title": "观察与认可",
                "text": "流程始于教师的专注观察。透过刻意的陪伴与辨识，教师识别学生的挣扎迹象、行为转变或正在浮现的需要。"
              },
              {
                "title": "主动接触",
                "text": "无论学生是否选择倾诉心事，教师都会主动表达支持——例如送上一张载有个人化鼓励与关怀讯息的卡片——以传达学生被看见、被重视的讯息。"
              },
              {
                "title": "接收与反思",
                "text": "学生接收并内化这份关怀的表达。是次互动随后会被记录于系统之中，引发结构化反思，并确保关怀得以延续。"
              },
              {
                "title": "个人化支援与复元",
                "text": "在安全而舒适的环境中，学生透过系统获取个人化的牧养关怀讯息。这让学生能够在没有过度压力或焦虑的情况下，自主地获得舒缓与情绪调节。"
              },
              {
                "title": "专业辅导",
                "text": "系统可与 OpenUp 无缝整合，以提供专业辅导服务。学生在需要时，能够安心且信任地获得合资格的专业支援。"
              },
              {
                "title": "持续跟进与关系建立",
                "text": "教师再次与学生接触，巩固关系并加深信任。每一次互动都为持续演进的记录增添内容，确保关怀随着时间保持一致、知情且适切回应。"
              }
            ]
          },
          "features": {
            "tag": "功能",
            "title": "认可层与牧养关怀层",
            "recognition": {
              "title": "察觉并命名美好之处",
              "items": [
                {
                  "title": "美德与价值卡",
                  "text": "以双语名称及卡面艺术定义学校的性格价值。印制专属二维码卡、管理库存、分配予教师，并追踪每一次解锁。"
                },
                {
                  "title": "学生快速解锁",
                  "text": "学生扫描、仅以班别及学号识别，并撰写简短反思。领取卡片无需注册帐户。"
                },
                {
                  "title": "性格档案",
                  "text": "解锁记录累积成可列印的档案，并附有成就奖章。校外成就亦可提交，由教师核实。"
                },
                {
                  "title": "性格报告",
                  "text": "根据多年来的真实证据生成。教师审阅并发布；学生与家长仅可查看已获批准的报告。"
                }
              ]
            },
            "pastoral": {
              "title": "在关键时刻察觉并回应",
              "items": [
                {
                  "title": "Check-In 讯息",
                  "text": "AI 协助策划简短、温和的 Check-In 讯息予学生——是一份关怀的问候，而非召唤。"
                },
                {
                  "title": "牧养关怀类型",
                  "text": "定义学校提供的关怀种类——学业、情绪、社交、家庭、行为、灵性——并附双语名称。"
                },
                {
                  "title": "关怀记录",
                  "text": "每一次 Check-In 都成为学生的关怀纪录的一部分——让模式得以浮现，跟进有据可依，而非凭空猜测。"
                },
                {
                  "title": "提示伫列",
                  "text": "当学生发出困扰讯号或模式出现转变时，合适的教职员会及早获通知——而非在危机之后。"
                },
                {
                  "title": "教职员权限",
                  "text": "班主任、辅导员及牧养主管各取所需——权限设定保障学生的尊严。"
                }
              ]
            }
          },
          "ai": {
            "tag": "一个平台，一份记录",
            "title": "教师主导，AI 辅助",
            "intro": "AI 负责记忆。教师负责连结。",
            "bullets": [
              "浮现学生卡片、反思与 Check-In 之间的模式",
              "根据真实证据起草性格报告——但从不自行发布",
              "标示语气或参与度的变化，供人手审阅",
              "从不取代教师的判断，亦从不直接联络学生"
            ],
            "gate": "教师发布关卡：每一份报告、每一个提示、每一次家庭通讯，都必须经过人手处理。"
          },
          "principles": {
            "tag": "信任与设计原则",
            "title": "我们如何赢得信任",
            "items": [
              {
                "title": "以强项为本，绝不惩罚",
                "text": "认可与关怀——没有扣分，没有惩罚追踪。"
              },
              {
                "title": "学生安全为预设",
                "text": "私密、获授权、保有尊严。学生被看见，而非被监视。反思与回应保持原样——不强制翻译。"
              },
              {
                "title": "手机友善",
                "text": "为手机而设——在走廊、在课室、在辅导室。"
              },
              {
                "title": "学校品牌",
                "text": "你的价值、你的卡面艺术、你的身份。"
              }
            ]
          },
          "who": {
            "tag": "适合谁使用",
            "title": "为学校每一个角色而设",
            "intro": "一个平台，一份记录——多种使用方式。",
            "rows": [
              {
                "role": "校长",
                "gets": "全校性格与关怀文化的实证"
              },
              {
                "role": "教师",
                "gets": "数秒内察觉、行动、跟进——系统保留记录"
              },
              {
                "role": "辅导员／牧养主管",
                "gets": "清晰的关怀纪录、及早提示、模式而非猜测"
              },
              {
                "role": "学生",
                "gets": "扫描、反思、成长——并被问及你真正过得如何"
              },
              {
                "role": "家长",
                "gets": "看见强项与关怀，无需另一个复杂的登入"
              }
            ]
          },
          "northStar": {
            "tag": "我们的北极星",
            "quote": "每位学生离开中学时，都带着一段关于自己正在成为谁的一以贯之、以强项为本的故事——以及至少一段支撑这段旅程的信任成人关系。"
          },
          "next": {
            "tag": "下一步",
            "title": "准备好见证 Harbour 的实际运作了吗？",
            "options": [
              "即时示范导览",
              "为你的学校而设的试行计划",
              "与团队问答交流"
            ],
            "ctaPrimary": "预约示范",
            "ctaSecondary": "联络团队"
          }
        },
        "cta": {
          "tag": "",
          "title": "",
          "text": "",
          "whatsapp_label": "",
          "form_label": "",
          "closing": ""
        }
      },
      "en": {
        "subtitle": "A safe place where students are truly known.",
        "summary": "Harbour is a bilingual character-strengths and pastoral-care platform for secondary schools. It turns everyday recognition and everyday care into one continuous story of each student’s growth — and safeguards the trusted relationships that carry that journey.",
        "hero_alt": "",
        "blocks": {
          "hero": {
            "tag": "See · Name · Nurture",
            "title": "My Harbour",
            "description": "Harbour is a bilingual character-strengths and pastoral-care platform for secondary schools. It turns everyday recognition and everyday care into one continuous story of each student’s growth — and safeguards the trusted relationships that carry that journey.",
            "subtitle": "A safe place where students are truly known.",
            "ctaPrimary": "Book a demo",
            "ctaSecondary": "See how it works"
          },
          "problem": {
            "tag": "The problem",
            "title": "One case is one too many.",
            "intro": "We have heard too many stories of young people with nowhere to turn. Schools do care — but care that lives only in memory, in corridor conversation and on paper notes cannot protect every student at whole-school scale.",
            "bullets": [
              "Recognition passes in a moment and never becomes a record. A teacher notices a student’s growth; without a record it disappears — invisible in reports, invisible in the year, invisible in the student’s own story.",
              "Pastoral signals are scattered across staff and systems. One teacher notices a student withdrawing, another notices skipped lunches, a third notices a drop in grades. Nobody sees the pattern.",
              "Relationships are built in calm moments, not in crises. Like a routine health check, regular low-key check-ins build the trust that lets us notice change early — and talk honestly when it matters. A relationship built in crisis is already too late.",
              "Parents and school each hold half the picture. What a teacher sees in class and what a parent sees at home are two halves of the same story. Without a steady two-way exchange, both act on a partial understanding — while the student moves alone between two disconnected worlds."
            ]
          },
          "beliefs": {
            "tag": "Our beliefs",
            "title": "What we believe",
            "items": [
              {
                "title": "Connection must be constant — not reserved for moments of crisis.",
                "text": "Relationships are cultivated, not hunted. A good relationship is never the result of a single intervention; it grows slowly through moments of being seen every day. Like a routine health check, a regular check-in is preventive care — it builds trust and familiarity, so we notice change early, long before worry becomes crisis."
              },
              {
                "title": "Young people need to feel supported in an environment they trust.",
                "text": "Support only works when it is safe, private and dignified. Trust comes first — it is not a reward. When the relationship already exists, students are far more willing to speak honestly; summoned only because there is a problem, it rarely works."
              },
              {
                "title": "Technology should support people’s work at scale.",
                "text": "One teacher can hold a few relationships in memory; a school cannot. Technology should carry the memory, surface the signals, and protect the time teachers need to stay with people — so that no recognition is lost and no pattern is overlooked."
              },
              {
                "title": "Parents and school are equal partners in caring for students.",
                "text": "A student’s journey is shaped by family and school together — and neither can hold the whole picture alone. Parents are not an audience receiving information; they co-own the caring relationship. When both sides keep sharing what they see, students are held by one consistent network instead of drifting between two disconnected worlds."
              },
              {
                "title": "Care must be continuous, not occasional.",
                "text": "A single conversation, however well meant, cannot carry a student through an entire school career. Care has to be a steady rhythm — visible, recorded, revisable — so that each student is known over time and not only in difficulty. That continuity is what turns scattered kindness into one continuous story of who a student is becoming."
              }
            ]
          },
          "design": {
            "tag": "Design philosophy",
            "title": "Strengths first. Teachers at the centre. Student-safe. AI-assisted.",
            "intro": "Every feature has to pass one test:",
            "test": "“Does this deepen genuine human connection and positive character growth, and provide pastoral care?”",
            "closing": "If it does not, we do not ship it."
          },
          "vision": {
            "tag": "Product vision",
            "title": "One platform. One story of growth.",
            "intro": "One platform where every teacher can notice, name and nurture a student’s character strengths — and where every student is known, supported, and carries one continuous story of who they are becoming.",
            "pillars": [
              "One dashboard. One student record. One alert queue. One reporting layer. Praise and care are not separate systems — a student needs encouragement on a hard day just as much as on a day of achievement. Both moments are supported in the same relationship platform.",
              "It is the only approach that empowers educators to build a relationship with students — one that can nurture success and hold failure, too."
            ]
          },
          "how": {
            "tag": "How it works",
            "title": "Observe → Reach out → Receive → Self-regulate → Professional support → Follow up",
            "intro": "A pastoral journey that begins with a teacher’s first observation and builds, step by step, a relationship worth trusting — alongside the student throughout.",
            "steps": [
              {
                "title": "Observation and recognition",
                "text": "The journey starts with a teacher’s focused observation. Through deliberate time together and careful noticing, the teacher identifies signs of struggle, shifts in behaviour, or needs that are beginning to surface."
              },
              {
                "title": "Reaching out",
                "text": "Whether or not the student chooses to open up, the teacher reaches out first — for example with a card carrying a personal word of encouragement and care — so the student knows they have been seen and valued."
              },
              {
                "title": "Receiving and reflecting",
                "text": "The student receives that expression of care and takes it in. The interaction is then recorded in the system, prompts a structured reflection, and ensures the care carries forward."
              },
              {
                "title": "Personalised support and recovery",
                "text": "In a safe and comfortable setting, the student draws personalised pastoral messages through the system. This lets them find relief and regulate their emotions on their own terms, without undue pressure or anxiety."
              },
              {
                "title": "Professional counselling",
                "text": "The system integrates seamlessly with OpenUp to provide professional counselling. When a student needs it, they can reach qualified professional support with confidence and trust."
              },
              {
                "title": "Follow-up and relationship building",
                "text": "The teacher reconnects with the student, consolidating the relationship and deepening trust. Every interaction adds to a record that keeps evolving, so care stays consistent, informed and responsive over time."
              }
            ]
          },
          "features": {
            "tag": "Features",
            "title": "The recognition layer and the pastoral layer",
            "recognition": {
              "title": "Notice and name what is good",
              "items": [
                {
                  "title": "Virtues and values cards",
                  "text": "Define the school’s character values with bilingual names and card artwork. Print QR-linked cards, manage stock, distribute them to teachers, and track every unlock."
                },
                {
                  "title": "Quick student unlock",
                  "text": "Students scan, identify with class and student number only, and write a short reflection. Collecting a card needs no account."
                },
                {
                  "title": "Character portfolio",
                  "text": "Unlocks accumulate into a printable portfolio, complete with achievement badges. Achievements outside school can be submitted and verified by a teacher."
                },
                {
                  "title": "Character report",
                  "text": "Generated from years of real evidence. Teachers review and publish; students and parents see only approved reports."
                }
              ]
            },
            "pastoral": {
              "title": "Notice and respond at the critical moments",
              "items": [
                {
                  "title": "Check-in messages",
                  "text": "AI-assisted drafting of short, gentle check-in messages for students — a greeting of care, not a summons."
                },
                {
                  "title": "Pastoral care types",
                  "text": "Define the kinds of care the school offers — academic, emotional, social, family, behavioural, spiritual — each with bilingual names."
                },
                {
                  "title": "Care record",
                  "text": "Every check-in becomes part of the student’s care record — so patterns can surface and follow-up is evidence-based rather than guesswork."
                },
                {
                  "title": "Alert queue",
                  "text": "The right staff are notified early when a student sends a signal of distress or a pattern shifts — not after the crisis."
                },
                {
                  "title": "Staff permissions",
                  "text": "Class teachers, counsellors and pastoral leads each get what they need — permission settings protect the student’s dignity."
                }
              ]
            }
          },
          "ai": {
            "tag": "One platform, one record",
            "title": "Teacher-led, AI-assisted",
            "intro": "AI remembers. Teachers connect.",
            "bullets": [
              "Surfaces patterns across a student’s cards, reflections and check-ins",
              "Drafts character reports from real evidence — but never publishes them",
              "Flags shifts in tone or engagement for a human to review",
              "Never replaces a teacher’s judgement, and never contacts a student directly"
            ],
            "gate": "The teacher publish gate: every report, every alert and every message home passes through a human first."
          },
          "principles": {
            "tag": "Trust and design principles",
            "title": "How we earn trust",
            "items": [
              {
                "title": "Strengths-based, never punitive",
                "text": "Recognition and care — no deductions, no punishment tracking."
              },
              {
                "title": "Student-safe by default",
                "text": "Private, permissioned, dignified. Students are seen, not surveilled. Reflections and replies stay as written — no forced translation."
              },
              {
                "title": "Mobile-first",
                "text": "Built for a phone — in the corridor, in the classroom, in the counselling room."
              },
              {
                "title": "School branding",
                "text": "Your values, your card artwork, your identity."
              }
            ]
          },
          "who": {
            "tag": "Who it is for",
            "title": "Built for every role in a school",
            "intro": "One platform, one record — many ways to use it.",
            "rows": [
              {
                "role": "Principal",
                "gets": "Evidence of the school’s whole character and culture of care"
              },
              {
                "role": "Teacher",
                "gets": "Notice, act and follow up in seconds — the system keeps the record"
              },
              {
                "role": "Counsellor / pastoral lead",
                "gets": "A clear care record, early alerts, patterns instead of guesswork"
              },
              {
                "role": "Student",
                "gets": "Scan, reflect, grow — and be asked how you are really doing"
              },
              {
                "role": "Parent",
                "gets": "See strengths and care, without another complicated login"
              }
            ]
          },
          "northStar": {
            "tag": "Our North Star",
            "quote": "Every student leaves secondary school carrying one continuous, strengths-based story of who they are becoming — and at least one trusted adult relationship that carried that journey."
          },
          "next": {
            "tag": "Next step",
            "title": "Ready to see Harbour in action?",
            "options": [
              "A live guided demo",
              "A pilot programme for your school",
              "A Q&A with the team"
            ],
            "ctaPrimary": "Book a demo",
            "ctaSecondary": "Contact the team"
          }
        },
        "cta": {
          "tag": "",
          "title": "",
          "text": "",
          "whatsapp_label": "",
          "form_label": "",
          "closing": ""
        }
      }
    }
  }
]
